export const ERASER_LABEL = "eraser"
export const CYCLE_LIST = [
  {
    value: "1er cycle",
    label: "1er cycle"
  },
  {
    value: "2è cycle",
    label: "2è cycle"
  },
  {
    value: "3è cycle",
    label: "3è cycle"
  },
]

export const TAGS_LIST = [
  // {
  //   value: "primary_1",
  //   label: "Primaire 1",
  //   cycle: CYCLE_LIST[0]
  // },
  // {
  //   value: "primary_2",
  //   label: "Primaire 2",
  //   cycle: CYCLE_LIST[0]
  // },
  {
    value: "primary_3",
    label: "Primaire 3",
    cycle: CYCLE_LIST[1]
  },
  {
    value: "primary_4",
    label: "Primaire 4",
    cycle: CYCLE_LIST[1]
  },
  {
    value: "primary_5",
    label: "Primaire 5",
    cycle: CYCLE_LIST[1]
  },
  {
    value: "primary_6",
    label: "Primaire 6",
    cycle: CYCLE_LIST[1]
  },
  // {
  //   value: "secondary_1",
  //   label: "Secondaire 1",
  //   cycle: CYCLE_LIST[2]
  // },
];

export const INITIAL_DIFFICULTY = 2;
